import PropTypes from 'prop-types';
import { ConfigProvider } from 'antd';

const PRIMARY = '#DD6633';
const DARK_BG = '#212121';

export default function ThemeCustomization({ children }) {
  return (
    <ConfigProvider
      componentSize="large"
      theme={{
        token: {
          colorPrimary: PRIMARY,
          colorSuccess: '#52c41a',
          colorWarning: '#faad14',
          colorError: '#f5222d',
          colorInfo: '#1677ff',
          borderRadius: 8,
          borderRadiusLG: 12,
          borderRadiusSM: 6,
          fontFamily: "'Public Sans', sans-serif",
        },
        components: {
          Layout: {
            siderBg: DARK_BG,
            triggerBg: DARK_BG,
          },
          Menu: {
            darkItemBg: DARK_BG,
            darkSubMenuItemBg: '#2a2a2a',
            darkItemSelectedBg: PRIMARY,
            darkItemHoverBg: '#2e2e2e',
            darkPopupBg: DARK_BG,
            darkItemSelectedColor: '#fff',
          },
          Segmented: {
            itemSelectedBg: PRIMARY,
            itemSelectedColor: '#fff',
            itemHoverBg: '#f5f5f5',
          },
        },
      }}
    >
      {children}
    </ConfigProvider>
  );
}

ThemeCustomization.propTypes = { children: PropTypes.node };
